<template>
  <b-row>
    <b-col sm="12">
      <b-card :title = "metadata.label">
        <template v-for="(element, i) in manyvalue">
          <div class="card" v-bind:key="'card_'+i">
            <div class="card-header no-border">
              <div class="card-tools">
                <button type="button" class="btn bg-info btn-sm" @click="eliminar(i)">
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
            <div class="card-body">
              <template v-for="(item, index) in metadata.children">
                <FormComponent :metadata='item' :dbfield='index' :key='"comp_"+ i + "_" +index' v-model="manyvalue[i][index]"
                    v-on:input="$emit('input', manyvalue)" :isEdit="isEdit" :isSearch="isSearch"
                    v-on:updatex="updatex"/>
              </template>
            </div>
          </div>
        </template>
        <b-row>
          <b-col md="2"><b-button @click="addToMany()">Agregar {{metadata.label}}</b-button></b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import FormComponentBase from './FormComponentBase'

export default {
  name: 'FormComponentGroup',
  extends: FormComponentBase,
  components: {
    FormComponent: () => import('./FormComponent')
  },
  data () {
    return {
      manyvalue: []
    }
  },
  watch: {
    value: function (val) {
      this.$set(this, 'manyvalue', val)
      this.$emit('valuechange', val)
    }
  },
  mounted () {
    if (this.value) {
      this.manyvalue = this.value
    }
  },
  methods: {
    addToMany () {
      this.manyvalue.push({})
    },
    eliminar (i) {
      var obj = this
      this.$dialog.confirm('Seguro que desea eliminar el elemento?', { okText: 'Eliminar', cancelText: 'Cancelar' })
        .then(function () {
          obj.$delete(obj.manyvalue, i)
        }).catch(function () {
          console.log('Clicked on cancel')
        })
    }
  }
}
</script>
